import { render, staticRenderFns } from "./VueBaseDialog.vue?vue&type=template&id=434f181c&scoped=true"
import script from "./VueBaseDialog.vue?vue&type=script&lang=js"
export * from "./VueBaseDialog.vue?vue&type=script&lang=js"
import style0 from "./VueBaseDialog.vue?vue&type=style&index=0&id=434f181c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f181c",
  null
  
)

export default component.exports